
import React, { useEffect, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { Box, Button, TextField } from "@mui/material";
import clsx from "clsx";
import { Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { emptyValidation } from "../../../../../helpers/validation";
import crudActions from "../../../../CRUD/redux/actions";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";


export const CopyRole = (props) => {
    const { roleDetails, copyVisible, handleCopyClose } = props;
    const { createLoader } = useSelector(state => state.crudReducer);
    const [visible, setVisible] = useState(false);
    const [errorRoleId, setErrorRoleId] = useState(false);
    const [errorName, setErrorName] = useState(false);

    const [form, setForm] = useState({
        roleId: "",
        name: ""
    });

    const dispatch = useDispatch();

    useEffect(() => {
        setVisible(copyVisible)
    }, [copyVisible]);

    const handleClose = () => {
        handleCopyClose();
        emptyStateInput();
        emptyState();
    };

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }

    };

    const emptyStateInput = () => {
        setForm({
            roleId: "",
            name: ""
        });
    }

    const emptyState = () => {
        setErrorRoleId(false);
        setErrorName(false);
    }

    const copyComponent = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', form.name);
        let emptyRole = emptyValidation('Role', form.roleId, 'dropDown');
        if (emptyName.isValid && emptyRole.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: `role/${form.roleId}/clone`,
                title: 'Role',
                details: {
                    "name": form.name
                }
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyRole.errors) {
                setErrorRoleId(emptyRole.errors);
            }
        }
    }

    const handleAddMore = () => {
        copyComponent();
    }

    const customObject = (details, id) => {
        let a = details && details?.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const classes = customStyles();
    return (
        <PrimaryDrawer
            anchor={'right'}
            open={visible}
            variant={'temporary'}
            handleClose={() => handleClose()}
            title={`Copy Role`}
            width={'360px'}
            className={classes.closeBackGround}
            component={
                <Box
                    className={clsx(classes.customForm, classes.removeUnderline)}
                    component="form"
                    autoComplete="off"
                    onSubmit={(e) => copyComponent(e)}>
                    <div className={classes.customFormFlex}>
                        <AutoCompleteComponent
                            name={["Role ", <span key={"Role"} className={classes.colorRedRequired}> *</span>]}
                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                            details={roleDetails}
                            parentValue={customObject(roleDetails, form.roleId)}
                            onChange={(data) => changeHandler(data.id, 'roleId')}
                            position={"bottom"}
                            parentError={errorRoleId}
                        />
                        <TextField autoComplete='one-time-code'
                            label={["New Role Name ", <span key={"New Role Name"} className={classes.colorRedRequired}> *</span>]}
                            variant={'standard'}
                            className={clsx(classes.margin30t)}
                            error={errorName ? true : false}
                            helperText={errorName}
                            name={"name"}
                            value={form.name}
                            InputProps={{
                                classes: {
                                    input: classes.textFieldColor,
                                }
                            }}
                            InputLabelProps={{
                                className: classes.textFieldLableColorCustom,
                            }}
                            onChange={(e) => changeHandler(e)}
                        />
                    </div>
                    <div className={clsx(classes.btnParent)}>
                        <Space direction="horizontal" align="center" size={[10, 10]}>
                            <Button
                                key="save"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                            >Save & Close</Button>
                            <Button
                                key="add"
                                onClick={(e) => handleAddMore(e)}
                                color='primary'
                                variant="contained"
                                className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                            >
                                Add more
                            </Button>
                        </Space>
                    </div>
                </Box>
            }
        />
    )
}